// Number formatting helpers for thousand separators + clean tabular display.
// Note: we intentionally lock numbers to "en-US" Latin digits across both UI
// languages — every iSaloon salon (Gulf region) explicitly requested Latin
// numerals because mixed Arabic-Indic digits in receipts/POS confuse staff.
export const fmt = (n, decimals = 2) => {
  const num = Number(n) || 0;
  return num.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const fmtInt = (n) => {
  const num = Number(n) || 0;
  return num.toLocaleString("en-US");
};

/**
 * Format a date / datetime / ISO string in the active language's locale.
 * Used across Bookings, Accounting, Purchases, Accounts so dates stop
 * leaking as raw ISO ("2026-06-03T14:30:00") in the UI.
 *
 * @param {Date|string|null|undefined} d
 * @param {"ar"|"en"} lang
 * @param {"date"|"datetime"|"time"} kind
 */
export const fmtDate = (d, lang = "en", kind = "datetime") => {
  if (!d) return "—";
  try {
    const date = d instanceof Date ? d : new Date(d);
    if (Number.isNaN(date.getTime())) return String(d);
    const locale = lang === "ar" ? "ar-EG" : "en-US";
    if (kind === "date") {
      return date.toLocaleDateString(locale, { year: "numeric", month: "short", day: "numeric" });
    }
    if (kind === "time") {
      return date.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
    }
    return date.toLocaleString(locale, {
      year: "numeric", month: "short", day: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return String(d);
  }
};

// Date range helpers for reports
export const dateRangePresets = (preset) => {
  const today = new Date();
  const y = today.getFullYear();
  const m = today.getMonth();
  const pad = (n) => String(n).padStart(2, "0");
  const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

  if (preset === "today") return { start: iso(today), end: iso(today) };
  if (preset === "month") {
    return { start: iso(new Date(y, m, 1)), end: iso(new Date(y, m + 1, 0)) };
  }
  if (preset === "prev_month") {
    return { start: iso(new Date(y, m - 1, 1)), end: iso(new Date(y, m, 0)) };
  }
  if (preset === "year") {
    return { start: `${y}-01-01`, end: `${y}-12-31` };
  }
  if (preset === "prev_year") {
    return { start: `${y - 1}-01-01`, end: `${y - 1}-12-31` };
  }
  return { start: "", end: "" };
};
